import React from 'react';
import {useLocation, useNavigate, useParams} from 'react-router';

const withRouter = (Component) => {
    const Wrapper = (props) => {
        const location = useLocation();
        const navigate = useNavigate();
        const params = useParams();

        const history = {
            push: (to) => navigate(to),
            replace: (to) => navigate(to, {replace: true}),
            go: (n) => navigate(n),
            goBack: () => navigate(-1),
            goForward: () => navigate(1),
        };

        return <Component {...props} history={history} location={location} match={{params}}/>;
    };
    Wrapper.displayName = `withRouter(${Component.displayName || Component.name || 'Component'})`;
    return Wrapper;
};

export default withRouter;
